import React, { useEffect } from 'react'
import Dashboard from './components/Dashboard'
import Table from './components/Table'
import Console from './components/Console'
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

function UserTrack() {

  let {isAuth} = useSelector(state=>state.auth);

  const navigate = useNavigate();

  useEffect(()=>{
    if(isAuth === false)
      navigate("/login")
  },[isAuth])
  
  return (
    <div className='flex flex-col gap-4'>
        <Dashboard></Dashboard>
        <Console></Console>
        <Table></Table>
    </div>
  )
}

export default UserTrack